import { defineStore } from "pinia"
import { ProjectRentalIntakeItem } from "@/models/project-rental-intake-item.model"
import { ref, type Ref } from "vue"
import { usePriceAgreementsConstantTimeLookup } from "@/composables/store/price-agreements-constant-time-lookup"

export const useProjectsRentalIntakeItemsStore = defineStore(
  "projectsRentalIntakeItemsStore",
  () => {
    const projectsRentalIntakeItems: Ref<ProjectRentalIntakeItem[]> = ref([])

    const { getPriceAgreement, getUnitPrice } =
      usePriceAgreementsConstantTimeLookup<ProjectRentalIntakeItem>(
        projectsRentalIntakeItems,
        (item) => [item.project, item.rentalIntakeItem],
        (item) => item.unitPricePerDay
      )

    return {
      projectsRentalIntakeItems,
      getPriceAgreement,
      getUnitPrice
    }
  }
)
